import {createClient} from 'contentful';

// Contentful configuration --
const SPACE_ID = "nniu166iezwv";
const ACCESS_TOKEN = "3f15a13208110abbdce83a246458b3846cc994981993ca3307df80279aa9e0cc";
const PREVIEW_ACCESS_TOKEN = "8c1caaa92e7895e0b790b8b40f60014763f433ecd4014f22c182122a097af98b";

// Test if we need to preview...
const domain = window.location.host.split('.')[0];
const isStaging = domain === 'preview' || domain === 'localhost:5000';

// Client...
const clientOptions = isStaging ? {
  space: SPACE_ID,
  accessToken: PREVIEW_ACCESS_TOKEN,
  host: 'preview.contentful.com'
} : {
  space: SPACE_ID,
  accessToken: ACCESS_TOKEN,
  removeUnresolved: true
};
const Client = createClient(clientOptions);

export default Client;



// WEBPACK FOOTER //
// ./app/javascript/packs/stores/Client.js